export enum EAccess {
  DeniedMessage = 'Generic.Accessdenied',
  LineManager = 'LineManager',
  TrackManager = 'TrackManager',
  BusinessManagerStudent = 'BusinessManagerStudent',
  InstructorModule = 'InstructorModule',
  InstructorEvent = 'InstructorEvent',
}
